import { render } from "./Viewer.vue?vue&type=template&id=3aa28e9d&scoped=true"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"

import "./Viewer.vue?vue&type=style&index=0&id=3aa28e9d&scoped=true&lang=css"

import exportComponent from "D:\\Vue-Project\\Darli-Gallery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa28e9d"]])

export default __exports__